unit UFrameDataBase;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  Data.DB, XData.Web.JsonDataset, XData.Web.Dataset, UUtils, UWeb.Enum;

type
  TfrmDataBase = class(TFrame)
    cbbDataBasePesquisa: TComboBox;
    cdsDataBase: TXDataWebDataSet;
    cdsDataBaseid: TIntegerField;
    cdsDataBasenome_fantasia: TStringField;
    procedure cdsDataBaseAfterOpen(DataSet: TDataSet);
  private
    FPesquisarBanco : Boolean;
  public
    procedure ConfigurarDataBase;
    function GetFilterDataBase : string;
  protected procedure LoadDFMValues; override; end;

var
  frmDataBase: TfrmDataBase;

implementation

uses
  ConnectionModule;

{$R *.dfm}

procedure TfrmDataBase.cdsDataBaseAfterOpen(DataSet: TDataSet);
var
  lDataBaseId,
  lTagImg : string;
begin
  cbbDataBasePesquisa.Items.Clear;

  cdsDataBase.First;

  if TUtils.FUsuario.DataBase = 0 then
    cbbDataBasePesquisa.Items.Add('TODOS');

  while not cdsDataBase.Eof do
  begin
    cbbDataBasePesquisa.Items.Add(cdsDataBase.FieldByName('nome_fantasia').AsString);
    cdsDataBase.Next;
  end;

  cbbDataBasePesquisa.ItemIndex := 0;
end;

procedure TfrmDataBase.ConfigurarDataBase;
begin
  FPesquisarBanco := True;

  if (TUtils.FUsuario.Aliado <= 0) or (not TUtils.PossuiPermissao(
    cdsDataBase.EntitySetName.ToLower, TTipoPermissao.VISUALIZAR)) then
  begin
    FPesquisarBanco := False;
    TUtils.RemoverElementoPorId('divDataBasePesquisa');
  end
  else
  begin
    if TUtils.FUsuario.DataBase > 0 then
      cdsDataBase.QueryString := '$filter=id eq ' + TUtils.FUsuario.DataBase.ToString;

    cdsDataBase.Load;
  end;
end;

function TfrmDataBase.GetFilterDataBase: string;
begin
  Result := EmptyStr;

  if not FPesquisarBanco then
    Exit;

  if TUtils.FUsuario.DataBase > 0 then
    TUtils.FUsuario.DataBase.ToString
  else
  if cbbDataBasePesquisa.ItemIndex > 0 then
  begin
    cdsDataBase.RecNo := cbbDataBasePesquisa.ItemIndex;
    Result := cdsDataBase.FieldByName('id').AsString;
  end;
end;

procedure TfrmDataBase.LoadDFMValues;
begin
  inherited LoadDFMValues;

  cbbDataBasePesquisa := TComboBox.Create('cbbDataBasePesquisa');
  cdsDataBase := TXDataWebDataSet.Create(Self);
  cdsDataBaseid := TIntegerField.Create(Self);
  cdsDataBasenome_fantasia := TStringField.Create(Self);

  cbbDataBasePesquisa.BeforeLoadDFMValues;
  cdsDataBase.BeforeLoadDFMValues;
  cdsDataBaseid.BeforeLoadDFMValues;
  cdsDataBasenome_fantasia.BeforeLoadDFMValues;
  try
    Name := 'frmDataBase';
    Left := 0;
    Top := 0;
    Width := 215;
    Height := 61;
    TabOrder := 0;
    Visible := False;
    cbbDataBasePesquisa.SetParentComponent(Self);
    cbbDataBasePesquisa.Name := 'cbbDataBasePesquisa';
    cbbDataBasePesquisa.Left := 4;
    cbbDataBasePesquisa.Top := 6;
    cbbDataBasePesquisa.Width := 145;
    cbbDataBasePesquisa.Height := 23;
    cbbDataBasePesquisa.HeightPercent := 100.000000000000000000;
    cbbDataBasePesquisa.WidthPercent := 100.000000000000000000;
    cbbDataBasePesquisa.ItemIndex := -1;
    cdsDataBase.SetParentComponent(Self);
    cdsDataBase.Name := 'cdsDataBase';
    cdsDataBase.AfterOpen := cdsDataBaseAfterOpen;
    cdsDataBase.EntitySetName := 'data_base';
    cdsDataBase.Connection := DMConnection.ApiConnection;
    cdsDataBase.QueryTop := 124;
    cdsDataBase.Left := 160;
    cdsDataBase.Top := 2;
    cdsDataBaseid.SetParentComponent(cdsDataBase);
    cdsDataBaseid.Name := 'cdsDataBaseid';
    cdsDataBaseid.FieldName := 'id';
    cdsDataBaseid.Required := True;
    cdsDataBasenome_fantasia.SetParentComponent(cdsDataBase);
    cdsDataBasenome_fantasia.Name := 'cdsDataBasenome_fantasia';
    cdsDataBasenome_fantasia.FieldName := 'nome_fantasia';
    cdsDataBasenome_fantasia.Size := 255;
  finally
    cbbDataBasePesquisa.AfterLoadDFMValues;
    cdsDataBase.AfterLoadDFMValues;
    cdsDataBaseid.AfterLoadDFMValues;
    cdsDataBasenome_fantasia.AfterLoadDFMValues;
  end;
end;

end.